export const USERS_COLLECTION = 'users';
export const FILES_SUBCOLLECTION = 'files';

export const FILE_EXPIRY_MS = 7 * 24 * 60 * 60 * 1000;
export const FILE_PURGE_AFTER_DELETE_MS = 7 * 24 * 60 * 60 * 1000;

export const DOCUMENTS_PAGE_SIZE = 10;

export const FILE_MERGE_BUFFER_KEY = 'pdfgen:file-merge:pending';

export const EDIT_PDF_VIEWER_ROUTE = '/app/edit-pdf?tool=edit-pdf';

export const CONVERT_TOOL_ROUTES = {
  word: '/app/convert-pdf?tool=pdf-to-word',
  excel: '/app/convert-pdf?tool=pdf-to-excel',
  powerpoint: '/app/convert-pdf?tool=pdf-to-ppt',
  generic: '/app/convert-pdf?tool=convert-pdf',
} as const;
